import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageQuotationComponent } from './manage-quotation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppMaterialModule } from 'src/app/app-material.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { CustomPipeModule } from 'src/app/shared/pipes/custom-pipes.module';

import { ManageQuotationRoutingModule } from './manage-quotation-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    FormsModule,
    ManageQuotationRoutingModule,
    CustomPipeModule,
    AppMaterialModule,
  ],
  declarations: [ManageQuotationComponent],
})
export class ManageQuotationModule {}
